module.exports = __webpack_public_path__ + "static/media/07-06.0e673de7.png";